import { render, staticRenderFns } from "./TabSchedules.vue?vue&type=template&id=aaf96406&"
import script from "./TabSchedules.vue?vue&type=script&lang=js&"
export * from "./TabSchedules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports